export const PestOwnerRoleOptions = [
  {
    value: 'pest_client_manager',
    label: 'My manager',
  },
  {
    value: 'pest_client_employee',
    label: 'My technician',
  },
  {
    value: 'client_company_owner',
    label: 'Client company owner',
  },
  {
    value: 'client_company_manager',
    label: 'Pest control responsible (Client)',
  },
  // {
  //   value: 'client_company_employee',
  //   label: 'Client employee',
  // },
];

export const ClientOwnerRoleOptions = [
  {
    value: 'client_company_manager',
    label: 'My manager',
  },
];

export enum RoleTransformNames {
  pest_client = 'Pest owner',
  pest_client_manager = 'My manager',
  pest_client_employee = 'My technician',
  client_company_owner = 'Client company owner',
  client_company_manager = 'Pest control responsible (Client)',
  client_company_employee = 'Client employee',
}
